export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },

  {
    title: '平台ID',
    field: 'platformId',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '平台名称',
    field: 'platformName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '平台账户',
    field: 'accountName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '渠道ID',
    field: 'salesChannelId',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '渠道名称',
    field: 'salesChannelName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '模板',
    field: 'templateName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: '模板类型',
    field: 'v_templateType',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '账户状态',
    field: 'status',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
